import React, { useState, useEffect } from 'react';
import Gallery from '@hpstellar/pdp/Gallery/Gallery.js';

import withConfigurations from '../../../../product/components/product-configurations';
import { pdpGetIntelBadge } from '../../../components/pdp-intel-badge-container';
import withPageComponents from '../../../../page/components/with-page-components';
import AdaptiveImage from '../../../../shared/components/adaptive-image';
import BrightCove from '../../../../shared/components/brightcove';
import ImageModal from './image-modal'

import './pdp-gallery.less'

const mapImages = (images, variantImages, ctoConfigurations) => {
    const { color = "" } = ctoConfigurations || {};
    const normalizedColor = color.toLowerCase().replace(/\+/ig, '');
    return (variantImages || {})[normalizedColor] || images;
}

const getBadges = (badges) => {
    if (typeof document !== 'undefined') {
        try {
            let intelBadge = pdpGetIntelBadge(document.location);
            if (intelBadge) {
                const { url: imageUrl, message } = intelBadge;
                let imageAlt = message && message.length > 0 ? message[0] : 'Intel'
                return [...badges, { imageUrl, imageAlt }];
            }
        } catch (e) {
            return badges;
        }
    }
    return badges;
}

const pdpGallery = ({ productGallery, ctoConfigurations }) => {
    if (productGallery) {
        const { images, badges, variantImages } = productGallery;
        const [imageIndex, setImageIndex] = useState(-1);
        const [mounted, setMounted] = useState(false);
        //don't render gallery till interaction is made
        const [loadModal, setLoadModal] = useState(false)
        const mappedImages = mapImages(images, variantImages, ctoConfigurations);
        useEffect(() => {
            if (!mounted) {
                setMounted(!mounted);
            }
        })
        //TODO: Temp solution would be better to have Gallery component take lazyLoad as a prop
        return <>
            <Gallery
                badges={getBadges(badges)}
                onExpand={(index) => {
                    if (!loadModal) {
                        setLoadModal(true);
                    }
                    setImageIndex(index)
                }}
                className={`pdp-gallery${!mounted ? ' ssr' : ''}`}
                lazyLoad={!mounted ? '' : undefined}
            >
                {mappedImages.map((image, i) => {
                    if (!mounted && i > 0) {
                        return <div></div>
                    }
                    return (
                        image.type !== 'video' ?
                            <AdaptiveImage
                                key={i}
                                src={image.xlarge || image.lrg}
                                impolicy={null}
                                desktopWidth={1024}
                                tabletWidth={640}
                                mobileWidth={640}
                            /> : <BrightCove
                                key={i}
                                src={image.src}
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                }}
                                width='100%'
                                height='100%' />
                    )
                })}
            </Gallery>
            {loadModal && <ImageModal
                imageIndex={imageIndex}
                setImageIndex={setImageIndex}
                images={mappedImages}
            />}
        </>
    }
    return null;
}

export default withPageComponents(withConfigurations(pdpGallery), { components: ['product', 'productGallery'] })
